interface SiteCardProps {
  name: string;
  url: string;
  description: string;
  tags?: string[];
}

export default function SiteCard({ name, url, description, tags }: SiteCardProps) {
  const domainName = (() => {
    try {
      return new URL(url).hostname.replace('www.', '');
    } catch {
      return url;
    }
  })();

  return (
    <a
      href={url}
      target="_blank"
      rel="nofollow noopener noreferrer"
      className="block p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 group cursor-pointer"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 md:w-11 md:h-11 flex-shrink-0 rounded-lg bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
          <span className="text-primary-600 font-bold text-sm md:text-base">{name.charAt(0)}</span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
              {name}
            </h3>
            <span className="text-xs text-foreground-400 truncate">{domainName}</span>
          </div>
          <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
            {description}
          </p>
          {tags && tags.length > 0 && (
            <div className="mt-2.5 flex items-center gap-1.5 flex-wrap">
              {tags.map((tag) => (
                <span key={tag} className="inline-block px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </div>
        <div className="flex-shrink-0 flex items-center">
          <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 transition-colors text-lg"></i>
        </div>
      </div>
    </a>
  );
}